/**
 * Split a underscore case string to Captialalise
 * @param {string} word
 *
 * @input -> 'xift_is_powerful
 * @output -> xift Is Powerful
 */
export default function splitUnderscoreToCaptialise(word) {
	return word.replace(/(^|_)(\w)/g, function($0, $1, $2) {
		return ($1 && ' ') + $2.toUpperCase();
	});
}
